var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import '@mui/material/styles';
import '@mui/material/Typography';
var displaySizeTypographyMap = {
    '2xl': {
        fontSize: '4.5rem',
        lineHeight: '5.625rem',
        letterSpacing: "".concat(4.5 * (-2 / 100), "rem"),
    },
    xl: {
        fontSize: '3.75rem',
        lineHeight: '4.5rem',
        letterSpacing: "".concat(3.75 * (-2 / 100), "rem"),
    },
    lg: {
        fontSize: '3rem',
        lineHeight: '3.75rem',
        letterSpacing: "".concat(3 * (-2 / 100), "rem"),
    },
    md: {
        fontSize: '2.25rem',
        lineHeight: '2.75rem',
        letterSpacing: "".concat(2.25 * (-2 / 100), "rem"),
    },
    sm: {
        fontSize: '1.875rem',
        lineHeight: '2.375rem',
    },
    xs: {
        fontSize: '24px',
        lineHeight: '32px',
    },
};
var textSizeTypographyMap = {
    xl: {
        fontSize: '1.25rem',
        lineHeight: '1.875rem',
    },
    lg: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
    },
    md: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    sm: {
        fontSize: '.875rem',
        lineHeight: '1.25rem',
    },
    xs: {
        fontSize: '.75rem',
        lineHeight: '1.125rem',
    },
};
var FONT_WEIGHTS = {
    REGULAR: '400',
    MEDIUM: '500',
    SEMIBOLD: '600',
    BOLD: '800',
};
export var TYPOGRAPHY_VARIANTS = {
    'display-2xl-regular': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-2xl-medium': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-2xl-semibold': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-2xl-bold': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-xl-regular': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-xl-medium': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-xl-semibold': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-xl-bold': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-lg-regular': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-lg-medium': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-lg-semibold': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-lg-bold': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-md-regular': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-md-medium': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-md-semibold': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-md-bold': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-sm-regular': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-sm-medium': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-sm-semibold': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-sm-bold': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-xs-regular': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-xs-medium': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-xs-semibold': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-xs-bold': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-xl-regular': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-xl-medium': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-xl-semibold': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-xl-bold': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-lg-regular': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-lg-medium': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-lg-semibold': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-lg-bold': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-md-regular': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-md-medium': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-md-semibold': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-md-bold': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-sm-regular': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-sm-medium': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-sm-semibold': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-sm-bold': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-xs-regular': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-xs-medium': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-xs-semibold': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-xs-bold': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.BOLD }),
};
